import React, { useState } from 'react';
import { Flag, X } from 'lucide-react';
import { moderationAPI } from '../../lib/api';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';

const REASONS = [
  { key: 'spam', label: 'Spam' },
  { key: 'scam', label: 'Scam / Fraud' },
  { key: 'harassment', label: 'Harassment' },
  { key: 'hate_speech', label: 'Hate Speech' },
  { key: 'nudity', label: 'Inappropriate Content' },
  { key: 'violence', label: 'Violence' },
  { key: 'impersonation', label: 'Impersonation' },
  { key: 'copyright', label: 'Copyright Violation' },
  { key: 'other', label: 'Other' },
];

export default function ReportButton({ contentType, contentId, className = '' }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [details, setDetails] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!reason) { toast.error('Please select a reason'); return; }
    setSubmitting(true);
    try {
      await moderationAPI.report({ content_type: contentType, content_id: contentId, reason, details });
      toast.success('Report submitted. Our team will review it.');
      setOpen(false);
      setReason('');
      setDetails('');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to submit report');
    } finally { setSubmitting(false); }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} className={`flex items-center gap-1 text-xs text-zinc-500 hover:text-red-400 transition-colors ${className}`} data-testid={`report-btn-${contentType}-${contentId}`}>
        <Flag size={12} /> Report
      </button>

      {open && (
        <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-zinc-900 border border-zinc-700 w-full max-w-sm p-5" onClick={e => e.stopPropagation()} data-testid="report-modal">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-bold text-white flex items-center gap-2"><Flag size={16} className="text-red-400" /> Report Content</h3>
              <button onClick={() => setOpen(false)} className="text-zinc-500 hover:text-white"><X size={18} /></button>
            </div>
            <div className="space-y-2 mb-4">
              {REASONS.map(r => (
                <button
                  key={r.key}
                  onClick={() => setReason(r.key)}
                  className={`w-full text-left px-3 py-2 text-sm transition-colors ${reason === r.key ? 'bg-red-500/20 text-red-400 border border-red-500/50' : 'bg-zinc-800 text-zinc-300 border border-zinc-700 hover:border-zinc-600'}`}
                  data-testid={`reason-${r.key}`}
                >
                  {r.label}
                </button>
              ))}
            </div>
            <Textarea
              placeholder="Additional details (optional)"
              value={details}
              onChange={e => setDetails(e.target.value)}
              rows={2}
              className="bg-zinc-800 border-zinc-700 text-white text-sm mb-3"
              data-testid="report-details"
            />
            <Button onClick={handleSubmit} disabled={submitting || !reason} className="w-full bg-red-500 text-white font-bold" data-testid="submit-report-btn">
              {submitting ? 'Submitting...' : 'Submit Report'}
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
